export default "__VITE_ASSET__BudTTsR$__"